import { createStore } from "vuex";
import apiBase from "../services/api/apiBase";
import cart from "./modules/cart";
import ui from "./modules/ui";
import logos from "./modules/logos";
import customizations from "./modules/customizations";
import search from "./modules/search";
import createPersistedState from "vuex-persistedstate";
import { getUser, loginUser } from "@/services/api";

export default createStore({
  state: {
    registration: {
      name: "",
      email: "",
      password: "",
    },
    user: {},
    authChecked: false,
    activeProfile: "Maker",
    theme: "dark",
  },
  mutations: {
    setRegistration(state, payload) {
      state.registration = payload;
    },
    setUser(state, user) {
      state.user = user;
    },
    setRegisterConfirmed(state, value) {
      state.user = {
        ...state.user,
        registerConfirmed: value,
      };
    },
    setActiveProfile(state, profile) {
      state.activeProfile = profile;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
    setAuthChecked(state, value) {
      state.authChecked = value;
    },
  },
  actions: {
    async loginUser({ dispatch }, { email, password }) {
      await loginUser(email, password);
      await dispatch("loginUserByToken");
    },

    async loginUserByToken({ commit, dispatch }) {
      const resp = await getUser();
      const user = resp.data;

      commit("setUser", user);

      try {
        await dispatch("cart/fetchSummary", null, { root: true });
      } catch (e) {
        console.warn("Erro ao buscar os dados do carrinho:", e);
      } finally {
        commit("setAuthChecked", true);
      }

      return user;
    },

    async logout({ commit }) {
      try {
        await apiBase.post("/auth/logout");
      } catch (e) {
        console.warn("Falha ao fazer logout:", e);
      }

      commit("setUser", {});
      commit("setAuthChecked", true);
      commit("cart/RESET_CART", null, { root: true });
      commit("customizations/RESET_CUSTOMIZATIONS", null, { root: true });
      commit("logos/RESET_LOGOS", null, { root: true });
    },

    toggleTheme({ commit, state }) {
      const newTheme = state.theme === "dark" ? "light" : "dark";
      commit("setTheme", newTheme);
    },
  },
  getters: {
    registrationData: (state) => state.registration,
    activeProfile: (state) => state.activeProfile,
  },
  modules: {
    cart,
    ui,
    logos,
    customizations,
    search,
  },
  plugins: [
    createPersistedState({
      key: "mm:ps",
      paths: [
        "theme",
        "activeProfile",
        "cart.summary",
        "logos",
        "customizations",
      ],
    }),
  ],
});
